import React from 'react'

import firebase  from 'firebase/app';
import 'firebase/firestore'



export default class AssessmentsByCompany extends React.Component {
    constructor(props) {
        super(props)
        this.props = props
        this.loadData = this.loadData.bind(this)

        this.state = { 
            assessments: {}, 
            activities: {},
            competencies: {},
            cpIds: ['rcMZCi0QJ8nSJvK1eznG','CLjB8t3dHY5G85lilXib','gwOqShMP4veA11evWHFW','7GNUjIELmW8GbkzmYBE0','zWBUIq44IbVer1EgUgCH','Xp7jBn2xQZTmPyyE9RPG'] }
    }

    loadData0() {
        
        const assessments = this.state.assessments
        
        firebase.firestore()
            .collection('assessmentsByRater')
            .where('company.id','==','JFC').get()
            .then(snapshot => snapshot.docs.map(doc => {
                const assessment = doc.data()
                assessments[doc.id] = assessment
                this.setState({assessments })
                assessment.employee.get().then(eeDoc => assessments[doc.id].eeData = eeDoc.data())
                assessment.activities.map(activity => activity.get().then(actDoc => {
                    if (!assessments[doc.id].actData) assessments[doc.id].actData = {}
                    const activity = actDoc.data()
                    assessments[doc.id].actData[actDoc.id] = activity
                    this.setState({assessments })
                    activity.competencies.map( competency => competency.get().then(cp => { 
                        if (!assessments[doc.id].actData[actDoc.id].cps) assessments[doc.id].actData[actDoc.id].cps = {}
                        const cpData = cp.data()
                        assessments[doc.id].actData[actDoc.id].cps[cp.id] = cpData                        
                        this.setState({assessments })
                        
                        doc.ref.collection('answers').doc(actDoc.id).collection('competencies').doc(cp.id).collection('dimensions').get().then(snapshot =>
                            snapshot.docs.map(dimDoc => {
                                if (!assessments[doc.id].actData[actDoc.id].cps[cp.id].dims) assessments[doc.id].actData[actDoc.id].cps[cp.id].dims = {}
                                assessments[doc.id].actData[actDoc.id].cps[cp.id].dims[dimDoc.id] = dimDoc.data()
                                console.log('render')
                                this.setState({assessments })
                            }  )
                             )
                        
                             this.setState({assessments })
                    } ) )
                    }  ))

                
            }
        
            ))
        
    }
    componentWillMount() {
        this.loadData()
    }


    loadData() {
        
        const {assessments,activities,competencies,cpIds} = this.state

        const aCollection = firebase.firestore().collection('assessmentsByRater')
        const actCollection = firebase.firestore().collection('activities')
        const cpCollection = firebase.firestore().collection('competencies')

    const promises = []
    
    const ids_extract20180819 = ['elp0','flp0','flpops20180813_a_0','lead20180813_assessment_0',
        'lead_assessment0',
        'lead_b0','leap20180814_a_0','elp_assessment']

    const ids_extract20180919 = [ {prefix:'lead20180820__a_', start: 1, end: 14, withZero: false },
    {prefix:'elp20180828__a_', start: 1, end: 4, withZero: false },
    {prefix:'elp20180903_a_', start: 1, end: 12, withZero: true },
    {prefix:'flpops20180905_a_', start: 5, end: 11, withZero: false },
    {prefix:'flpops20180918_a_', start: 1, end: 3, withZero: true },
    {prefix:'lead20180820__a_', start: 1, end: 12, withZero: false },
    {prefix:'lead20180824__a_', start: 1, end: 9, withZero: false },
    {prefix:'leap20180907_a_', start: 1, end: 6, withZero: true },
    {prefix:'led20180907_a_', start: 1, end: 5, withZero: true },
    {prefix:'lead20180824__a_0', start: 10, end: 13, withZero: false }
    ]

    const ids = [ 
        {prefix:'flpops20180905_a_', start: 10, end: 11, withZero: false }
    ]
    let zero = ''   
    for(let j = 0; j < ids.length; j++) {
        let id = ids[j]
        console.log(id)
        for(let i = id.start;i <= id.end; i++) {
            if (id.withZero && i < 10) zero = '0'            
            console.log('assessments by company' +id.prefix + zero + i)
            promises.push(aCollection.doc(id.prefix + zero + i).get())
        }
    }


    Promise.all( promises )
        .then(docs =>
            docs.map(doc => { 
    
   /*
    aCollection.where('company.id','==','JFC').get().then(snapshot =>
            snapshot.docs.map(doc => {
*/

                const assessment = doc.data()
                if (assessment) {
                assessments[doc.id] = assessment
                this.setState({assessments})

                assessment.activities.map(activityRef => 
                    activities[activityRef.id]
                        ? null
                        : activityRef.get().then(actDoc => {
                            const activity = actDoc.data()
                            activities[actDoc.id] = activity
                            this.setState({activities})

                            activity.competencies.map(cpRef =>
                                competencies[cpRef.id] 
                                    ? null
                                    : cpRef.get().then(cpDoc => {
                                        const competency = cpDoc.data()
                                        competencies[cpDoc.id] = competency
                                        this.setState({competencies})

                                        Object.entries(competency.dimensions).map(([id,dimension]) => {
                                            doc.ref.collection('answers').doc(activityRef.id)
                                            .collection('competencies').doc(cpRef.id)
                                            .collection('dimensions').doc(id).get().then(dimDoc => {
                                                const indicator = dimDoc.data() 
                                                if (!assessments[doc.id].ansData) assessments[doc.id].ansData = {}
                                                if (!assessments[doc.id].ansData[cpRef.id + '_' + dimDoc.id]) assessments[doc.id].ansData[cpRef.id + '_' + dimDoc.id] = 
                                                    [{competency: competency.name,
                                                        dimension: dimension.name},{},{},{}] 
                                                if (indicator) {
                                                    const score = competencies[cpRef.id].dimensions[dimDoc.id].indicators[indicator.indicatorId].score
                                                    assessments[doc.id].ansData[cpRef.id + '_' + dimDoc.id][activity.sort]= { indicator, score}
                                                } 
                                                this.setState({assessments})

                                            })

                                        })

                                        })
                                )
                            }) 
                )
                assessment.employee.get().then(eeDoc => {
                    assessments[doc.id].eeData = eeDoc.data()
                    this.setState({assessments})
                } )

                } // end if assessment


            })
        )
           
        
    }

    render() {

        const {assessments, activities, competencies}  = this.state
        
        return <div><table><tbody>
            
    {Object.entries(assessments).length > 0 ? Object.entries(assessments).map( ( [assessmentIndex, value]) => 
                     
            value && value.ansData && Object.values(value.ansData).length > 0 
                    ? Object.values(value.ansData).map(answers => 
                        
            <tr>
                <td>{value.eeData ? value.eeData.firstName + ' ' + value.eeData.lastName: ''}</td>
                <td>{answers[0].competency}</td><td>{answers[0].dimension}</td>
                <td>{answers[1].score}</td>
                <td>{answers[2].score}</td>
                <td>{answers[3].score}</td>
            </tr>
                        
                         ) 
                    : <tr><td>Empty {assessmentIndex}</td></tr> 
            ) : <tr><td>Loading Assessments By Company</td></tr>}
            </tbody>
            </table>
            
            </div>
    }

}


// WEBPACK FOOTER //
// ./src/admin/components/AssessmentsByCompany.js